import { createSelector } from '@reduxjs/toolkit'
import type { WeighbridgeState } from './weighbridge.slice'

// Helper to find the state slice
const selectWeighbridgeState = (state: any): WeighbridgeState => {
  if (state.weighbridge) return state.weighbridge
  if (state.shipments?.weighbridge) return state.shipments.weighbridge
  // Fallback
  return state
}

export const selectFirstWeighTicket = createSelector(
  selectWeighbridgeState,
  (state) => state.firstWeighTicket
)

export const selectSecondWeighTicket = createSelector(
  selectWeighbridgeState,
  (state) => state.secondWeighTicket
)

export const selectWeighbridgeLoading = createSelector(
  selectWeighbridgeState,
  (state) => state.loading
)

export const selectWeighbridgeError = createSelector(
  selectWeighbridgeState,
  (state) => state.error
)

export const selectFirstWeighSuccess = createSelector(
  selectWeighbridgeState,
  (state) => state.firstWeighSuccess
)

export const selectSecondWeighSuccess = createSelector(
  selectWeighbridgeState,
  (state) => state.secondWeighSuccess
)

export const selectDeliveredSuccess = createSelector(
  selectWeighbridgeState,
  (state) => state.deliveredSuccess
)

export const selectStartProcessingResult = createSelector(
  selectWeighbridgeState,
  (state) => state.startProcessingResult
)

export const selectStartProcessingSuccess = createSelector(
  selectWeighbridgeState,
  (state) => state.startProcessingSuccess
)

export const selectBalanceCheckError = createSelector(
  selectWeighbridgeState,
  (state) => state.balanceCheckError
)

/**
 * Returns true if the last error was due to insufficient balance
 */
export const selectIsInsufficientBalanceError = createSelector(
  selectBalanceCheckError,
  (balanceCheck) => balanceCheck !== null && !balanceCheck.allowed
)
